
const digest = 'b348796fca8f9513b911b91697f7ae5b3ca66c7edf56aa1cf530cbdd5c34f13a';
const css = `._colorPicker_1nxwn_1 {
  width: 326px;
}

._colorSwatches_1nxwn_5 {
  display: grid;
  grid-template-columns: repeat(14, 16px);
  grid-gap: 6px;
  padding: 12px;
}

._colorSwatchContainer_1nxwn_12 {
  width: 16px;
  height: 16px;
}

._colorSwatchBorder_1nxwn_17 {
  border: 1px solid var(--aha-gray-200);
}

._colorSwatch_1nxwn_5 {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

._customColorSwatch_1nxwn_28 {
  display: block;
}

._colorControls_1nxwn_32 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 12px 12px;
}

._clearColorButton_1nxwn_39 {
  border: 0;
  background: none;
  color: inherit;
  cursor: pointer;
  border-radius: var(--Common--border-radius);
  padding: 4px 5px;
}

._clearColorButton_1nxwn_39:hover {
  background-color: var(--theme-menu-hover-background);
}

._customColor_1nxwn_28 {
  display: flex;
  align-items: center;
}

._customColorHex_1nxwn_57 {
  margin-left: 12px;
}

._customColorHexInput_1nxwn_61 {
  height: 20px;
  padding: 2px 6px !important;
  margin-bottom: 0 !important;
  border: 1px solid var(--aha-gray-400);
  border-radius: 0;
  font-size: 12px !important;
  width: 70px !important;
}

._customColorPickerContainer_1nxwn_71 {
  position: relative;
  width: 0;
  height: 0;
}

._customColorPicker_1nxwn_71 {
  position: fixed;
  padding: 6px;
  background-color: var(--theme-primary-background);
  border-radius: var(--Common--border-radius);
  box-shadow: var(--theme-shadow-shallow);
  border: 1px solid var(--theme-light-border);
}

/* Default positioning: below the toolbar with triangle pointing up */
._customColorPicker_1nxwn_71:after,
._customColorPicker_1nxwn_71:before {
  bottom: 100%;
  left: 19px;
  border: solid transparent;
  content: '';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

._customColorPicker_1nxwn_71:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: var(--theme-primary-background);
  border-width: 6px;
  margin-left: -6px;
}

._customColorPicker_1nxwn_71:before {
  border-color: rgba(0, 0, 0, 0);
  border-bottom-color: var(--theme-light-border);
  border-width: 7px;
  margin-left: -7px;
}

/* Above positioning: above the toolbar with triangle pointing down */
._customColorPickerAbove_1nxwn_114 {
  /* Move the color picker up 100% of its height, then 42px to account for the triangle */
  transform: translateY(-100%) translateY(-42px);
}

._customColorPickerAbove_1nxwn_114:after,
._customColorPickerAbove_1nxwn_114:before {
  bottom: auto;
  top: 100%;
  left: 19px;
  border: solid transparent;
  content: '';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

._customColorPickerAbove_1nxwn_114:after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: var(--theme-primary-background);
  border-bottom-color: transparent;
  border-width: 6px;
  margin-left: -6px;
}

._customColorPickerAbove_1nxwn_114:before {
  border-color: rgba(0, 0, 0, 0);
  border-top-color: var(--theme-light-border);
  border-bottom-color: transparent;
  border-width: 7px;
  margin-left: -7px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"colorPicker":"_colorPicker_1nxwn_1","colorSwatches":"_colorSwatches_1nxwn_5","colorSwatchContainer":"_colorSwatchContainer_1nxwn_12","colorSwatchBorder":"_colorSwatchBorder_1nxwn_17","colorSwatch":"_colorSwatch_1nxwn_5","customColorSwatch":"_customColorSwatch_1nxwn_28","colorControls":"_colorControls_1nxwn_32","clearColorButton":"_clearColorButton_1nxwn_39","customColor":"_customColor_1nxwn_28","customColorHex":"_customColorHex_1nxwn_57","customColorHexInput":"_customColorHexInput_1nxwn_61","customColorPickerContainer":"_customColorPickerContainer_1nxwn_71","customColorPicker":"_customColorPicker_1nxwn_71","customColorPickerAbove":"_customColorPickerAbove_1nxwn_114"};
export { css, digest };
  